import styled from "styled-components";

export default styled.div`
    position: absolute;
    top: 15px;
    left: 15px;

    width: 30px;
    height: 30px;
    border-radius: 15px;

    background: red;
    color: white;

    text-align: center;
    line-height: 30px;
    font-size: 20px;
`;
